import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { CUSTOMER_TRAVELPLAN_FILES } from '~/endpoints';
import { handleErrorResponse } from '~/helpers/api';
import { getSanctumBearerToken } from '~/helpers/sanctumAuth';
import { CustomerTravelplanFilesResponse } from '~/types/api';
import { MutationError } from '~/types/form';
import {
  CustomerTravelplanFilesRequestSchema,
  CustomerTravelplanFilesResponseSchema,
} from '~/validation/api/customerTravelplanFilesResponse';

export const getCustomerTravelplanFiles = async (travelplanId: string) => {
  const body = CustomerTravelplanFilesRequestSchema.parse(travelplanId);

  try {
    const api = CUSTOMER_TRAVELPLAN_FILES.replace(':travelplanId', body.toString());

    const response = await axios.post(api, null, {
      headers: {
        Authorization: getSanctumBearerToken(),
      },
    });

    const json = response.data;

    return CustomerTravelplanFilesResponseSchema.parse(json);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      throw await handleErrorResponse(error.response);
    }

    throw error;
  }
};

export function useCustomerTravelplanFiles(travelplanId: string, enabled: boolean) {
  return useQuery<CustomerTravelplanFilesResponse, MutationError>({
    queryKey: ['customerTravelplanFiles', travelplanId],
    queryFn: () => {
      return getCustomerTravelplanFiles(travelplanId);
    },
    retry: false,
    enabled,
  });
}
